// Copyright (c) 2025 by Audere

import { useGetConversationForLabelerQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { useSelector } from "react-redux";

export const useConversationForLabeler = (conversation_uid: string, labeling_type: string) => {
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);
  const {
    data: conversation,
    isLoading,
    isFetching,
    error,
  } = useGetConversationForLabelerQuery(
    {
      group: userGroupRole.group,
      conversation_uid,
      labeling_type,
      message_cursor: null,
      limit: 1000,
    },
    {
      pollingInterval: 0,
      skipPollingIfUnfocused: true,
      refetchOnFocus: false,
      refetchOnReconnect: true,
      skip: !conversation_uid,
    }
  );

  return { conversation, isLoading, isFetching, error };
};
